import { ChangeEvent } from "react"
import cn from "classnames"

import { Input as InputBrand } from "ui-kit/components-branded/index"
import style from "modules/NewClientSurvey/components/Input/style.module.scss"

interface Props {
    className?: string
    id: string
    value: string | number
    type: string
    error: string | undefined
    onChange: (questionId: string, value: string | number) => void
}

export function Input({ className, id, value, type, error, onChange }: Props) {
    function handleChangeInput(event: ChangeEvent<HTMLInputElement>) {
        let newValue

        if (type === "number") {
            const valueNumber = parseInt(event.target.value, 10)
            if (event.target.value.length === 0) newValue = 0
            else if (valueNumber > 0) newValue = valueNumber
            else newValue = value
        } else newValue = event.target.value

        onChange(id, newValue)
    }

    return (
        <div className={cn(style.container, className)}>
            <InputBrand value={value} isDanger={!!error} onChange={handleChangeInput} />
            <div className={style.error} title={error}>
                {error}
            </div>
        </div>
    )
}
